import { render, staticRenderFns } from "./NoResultsBanner.vue?vue&type=template&id=1afc809f&"
import script from "./NoResultsBanner.vue?vue&type=script&lang=js&"
export * from "./NoResultsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports